import { getAllPortarit, getVehicleHangar, getAllBodylib } from '@blade-sxp/task-management/api/creat-task/index';
const Servies = {
    getAllPortarit,
    getVehicleHangar,
    getAllBodylib
};
/**
 * 查询所有人像库数据
 * @returns OptionData[]
 */
export const libraryTypeData = () => {
    try {
        const data = [];
        Servies.getAllPortarit().then((it) => {
            const listData = it?.list || [];
            listData.forEach((item) => {
                data.push({ label: item.libraryName, value: item.libId });
            });
        });
        return data;
    }
    catch (error) {
        throw new Error('接口错误');
    }
};
/**
 * 查询车辆库 all data
 * @returns OptionData[]
 */
export const getVehicleHangarData = () => {
    try {
        const param = {
            libType: "AUTO_MOBILE",
            status: ['ENABLE']
        };
        const data = [];
        Servies.getVehicleHangar(param).then((it) => {
            const listData = it?.list || [];
            listData.forEach((item) => {
                data.push({ label: item.name, value: item.libId });
            });
        });
        return data;
    }
    catch (error) {
        throw new Error('车辆库接口错误');
    }
};
/**
 * 查询人体库 all data
 * @returns OptionData[]
 */
export const libraryBodyData = () => {
    try {
        const data = [];
        Servies.getAllBodylib().then((it) => {
            const listData = it?.list || [];
            listData.forEach((item) => {
                data.push({ label: item.libraryName, value: item.libId });
            });
        });
        return data;
    }
    catch (error) {
        throw new Error('接口错误');
    }
};
